import { ValueCalculator } from "./value-calculator";

export class MeanCalculator extends ValueCalculator {
  constructor(range) {
    super(0);
    this.elements = [];
    this.elements.length = range;
    this.elements.fill(0);
    this.sum = 0;
    this.elementCount = 0;
    this.range = range;
    this.index = 0;
  }

  calculate(newValue) {
    if (this.elementCount < this.range) {
      this.elements[this.elementCount] = newValue;
      this.elementCount++;
    } else {
      this.sum -= this.elements[this.index];
      this.elements[this.index] = newValue;
      this.index++;
      if (this.index == this.range) {
        this.index = 0;
      }
    }
    this.sum += newValue;
    this.measuredValue = this.sum / this.elementCount;
    return this.measuredValue;
  }

  reset(initValue) {
    this.measuredValue = initValue;
    this.sum = initValue;
    this.elements[0] = initValue;
    this.elementCount = 1;
    this.index = 1;
  }
}
